import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { ProductPackaging } from '@tradecafe/types/core'
import { sortBy } from 'lodash-es'
import { AngularCopy } from 'src/decorators/angular-copy.decorator'
import { AngularParams, HaveAngularParams } from 'src/decorators/angular-params.decorator'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment


@Injectable()
@AngularCopy()
export class ProductPackagingApiService {
  private http = inject(HttpClient)


  MaxRequestSize = 10000

  @HaveAngularParams()
  list(@AngularParams() params) {
    return this.http.get<{ data: ProductPackaging[] }>(`${apiUrl}/packagings`, { params }).toPromise().then(({data = []}) => {
      return {
        data: sortBy(data, 'name'),
      }
    })
  }

  create(data: Partial<ProductPackaging>) {
    return this.http.post<{ data: ProductPackaging }>(`${apiUrl}/packagings`, data).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: ProductPackaging }>(`${apiUrl}/packagings/${id}`).toPromise()
  }

  update(id: string, data: Partial<ProductPackaging>) {
    return this.http.put<{ data: ProductPackaging }>(`${apiUrl}/packagings/${id}`, data).toPromise()
  }

  delete(id: string) {
    return this.http.delete<{ data: ProductPackaging }>(`${apiUrl}/packagings/${id}`).toPromise()
  }
}
